import React, { Fragment } from 'react';
import FloatingSupport from '../components/FloatingSupport/FloatingSupport';

const ThankYouPage = () => {
    const handleSubcriptionPlan = async () => {
        if (window.opener) {
            window.opener.location.href = "/";
            window.close();
            localStorage.clear();
        } else {
            window.location.href = "/";
            localStorage.clear();
        }
    };
    return (
        <Fragment>
            <div style={styles.container}>
                <h1 style={styles.heading}>Transaction Successful!</h1>
                <p style={styles.paragraph}>
                    Your transaction has been processed successfully. Thank you for your payment!
                </p>
                <button className="btn btn-primary btn-sm me-1" onClick={handleSubcriptionPlan}>Go Back</button>
            </div>
            <FloatingSupport inline={true} auth={true} />
        </Fragment>
    );
};

const styles = {
    container: {
        textAlign: 'center',
        padding: '50px',
        fontFamily: 'Arial, sans-serif'
    },
    heading: {
        fontSize: '36px',
        color: '#4CAF50'
    },
    paragraph: {
        fontSize: '18px',
        margin: '20px 0'
    },
    link: {
        textDecoration: 'none',
        color: '#4CAF50',
        fontSize: '16px'
    }
};

export default ThankYouPage;
